import React from "react";
import "./eServices.scss";
import Qrcode from "../../images/qrcode_eservices.svg";
import AnimatedPage from "../AnimatedPage";
import MobileIcon from "../../images/mobile-screen-button-solid.svg";
import LibertanSuivi from "../../videos/libertan_suivi.mp4";
import LibertanSouscription from "../../videos/libertan_souscription.mp4";
import LibertanSuiviImg from "../../images/libertan_suivi.jpg";
import LibertanSouscriptionImg from "../../images/libertan_souscription.jpg";

const Eservices2 = () => {
  return (
    <AnimatedPage>
      <div className="eservices2__ctn">
        <div className="col col1">
          <h1>Consulter eServices sur votre smartphone</h1>
          <img className="qrcode" src={Qrcode} alt="QR Code Appli Tan" />
          <div className="icon-caption">
            <img className="mobile-icon" src={MobileIcon} alt="Icon Mobile" />
            <p className="scan">Scannez-moi</p>
          </div>
        </div>
        <div className="separator"></div>
        <div className="col col2">
          <h1>Guides d'utilisation eServices</h1>
          <video controls width="500" poster={LibertanSuiviImg}>
            <source src={LibertanSuivi} type="video/webm" />
          </video>
          <video controls width="500" poster={LibertanSouscriptionImg}>
            <source src={LibertanSouscription} type="video/webm" />
          </video>
          <p className="caption">Appuyez sur la vidéo pour regarder le guide</p>
        </div>
      </div>
    </AnimatedPage>
  );
};

export default Eservices2;
